export const AccountSearchParam = 'accountType';
export const ApplyParam = 'apply';
export const EmailSearchParam = 'email';
export const ReferralIdSearchParam = 'referralId';
